export default __webpack_public_path__ + "static/media/portfolio-161.e7319ca8.jpg";